import { Fields } from './types';

/**
 * List of interactive field types that can be disabled when parent conditions are not met
 */
export const INTERACTIVE_FIELD_TYPES = [
  Fields.switch,
  Fields.text,
  Fields.textarea,
  Fields.number,
  Fields.date,
  Fields.month,
  Fields.select,
  Fields.autocomplete,
  Fields.multiSelectAutocomplete,
  Fields.radioCheckboxes,
  Fields.heightPicker,
  Fields.asyncAutocomplete,
  Fields.intlPhoneNumber,
  Fields.checkbox,
  Fields.cardSelect,
  Fields.radioGroup,
  Fields.chipSelect,
  Fields.switchGroup
];

/**
 * Get the appropriate clear value for a given field type
 * @param fieldType - The field type from Fields enum
 * @returns The appropriate clear value for the field type
 */
export const getClearValueForFieldType = (fieldType: Fields) => {
  switch (fieldType) {
    case Fields.text:
    case Fields.textarea:
    case Fields.number:
    case Fields.autocomplete:
      return '';
    case Fields.multiSelectAutocomplete:
    case Fields.radioCheckboxes:
      return [];
    case Fields.switch:
    case Fields.checkbox:
    case Fields.select:
    case Fields.date:
    case Fields.heightPicker:
    case Fields.asyncAutocomplete:
    case Fields.intlPhoneNumber:
    case Fields.cardSelect:
    case Fields.radioGroup:
    case Fields.chipSelect:
    case Fields.month:
    default:
      return null;
  }
};
